// extracted by mini-css-extract-plugin
export default {"container":"checkbox_container__Pf-ok","input":"checkbox_input__BJzji","label":"checkbox_label__7Fk-Y","quantity":"checkbox_quantity__5FPbr","dotted":"checkbox_dotted__awPJL"};